module.exports = __webpack_public_path__ + "public/images/doctor.0b58fa18c503c98527d8ce7eb5db6978.webp";